import { Alert, Stack, Typography } from '@mui/material'

import { ManualDriverInvoiceBatchItemDto } from 'generated/graphql'
import { getQueuedMessage } from 'helpers'

interface IProps {
  items: Array<ManualDriverInvoiceBatchItemDto>
}

export const GenerateInvoiceResults = (props: IProps) => {
  const { items } = props

  const queued = items.filter((item) => item.isQueued).length

  return (
    <Stack spacing={1}>
      <Typography variant='subtitle1'>
        {queued} of {items.length} booking(s) queued
      </Typography>

      {queued > 0 && (
        <Typography variant='body2' color='text.secondary'>
          Generation runs in the background. The outcome is recorded in each booking&apos;s history,
          and the invoice and APR appear in the Invoices and Accounts Payable tabs once generated.
        </Typography>
      )}

      {items.map((item) => (
        <Alert key={item.bookingDriverId} severity={item.isQueued ? 'success' : 'error'}>
          <strong>
            {item.bookingReference} ({item.driverName}):
          </strong>{' '}
          {item.isQueued ? getQueuedMessage(item) : item.errorMessage}
        </Alert>
      ))}
    </Stack>
  )
}
